<template>
  <div class="bordered">

    <div class="container-fill" @click="toggle">
      <div>
        <b>{{ alert.changes[0].type }} {{ alert.type }}</b> in
          {{ alert.changes[0].asset.type }}
          <div v-show="isHost">
            {{ alert.changes[0].asset.ip }}
          </div>
      </div>
      <!--<div>{{ asset.type }} <span class="default" v-show="asset.default">(default)</span></div>-->
      
        
        (created: {{ alert.created }})
      
    </div>

    <div class="details" v-show="isActive">
      <!--<div id="profileButtons" v-show="!remediation.default">
        <font-awesome-icon icon="trash" @click="deleteProfile()" title="Delete profile"/>
      </div>-->
      <b>Asset ID:  </b>{{ alert.changes[0].asset_id }} <br/>
      <div v-show="isAttribute">  
            <b>Attribute:  </b>{{ alert.changes[0].attribute }} <br/>
            <b>Previous value:  </b> {{ alert.changes[0].prev_value }} <br/> 
            <b>New value:  </b> {{ alert.changes[0].curr_value }}
      </div>
      <div v-show="!isAttribute">  
            <b>Realated Asset ID:  </b>{{ alert.changes[0].related_asset_id }} <br/>
      </div>
      
    </div>
      
    <pre class="debug" v-show="debugMode">{{alert}}</pre>
    
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  computed: { 
    isHost () {
      return this.alert.changes[0].asset.type == 'host'
    },
    isAttribute() {
      return this.alert.changes[0].attribute != null
    },
    ...mapState([
      'debugMode'
    ])
  },
  data () {
    
    return {             
          isActive: false
          //profileName: this.profile.name      
        }      
    
  },  
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    }
  }
}
</script>
